"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomBackdrop = CustomBackdrop;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var StyleBackdrop = (0, _styles.styled)(_material.Backdrop)(function (_ref) {
  var theme = _ref.theme;
  return {
    zIndex: theme.zIndex.modal + 1,
    color: theme.palette.common.white
  };
});
function CustomBackdrop(props) {
  return /*#__PURE__*/_react["default"].createElement(StyleBackdrop, {
    open: props.open
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, props.children && props.children, !props.children && (/*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    justifyContent: "center"
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    pb: 2
  }, /*#__PURE__*/_react["default"].createElement(_material.CircularProgress, {
    color: "inherit"
  }))))), props.message && (/*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    justifyContent: "center"
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body1",
    component: "h6",
    align: "center"
  }, props.message))))));
}